import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { SeasonEntityTransformed } from "~pages/SeasonEntities/types/seasonEntityTransformed";
import { transformSeasonEntity } from "~pages/SeasonEntities/utilities/transformSeasonEntity";
import type { SeasonEntityResponse } from "~types/seasonEntity";

export const useGetSeasonEntity = () => {
  const request = useApi();
  const { organizationId, sport, seasonId, entityId } = useParams();

  return useQuery<SeasonEntityTransformed>({
    queryKey: ["seasonEntity", sport, organizationId, seasonId, entityId],
    enabled: !!entityId,
    queryFn: () =>
      request<SeasonEntityResponse>(
        `${sport}/o/${organizationId}/seasons/entities?seasonIds=${seasonId}&entityIds=${entityId}&include=seasons,entities,conferences,divisions`,
      ).then((response) => {
        const item = response?.data?.[0];
        if (!item) {
          throw new Error("Season entity not found");
        }

        return transformSeasonEntity(item, response?.includes?.resources);
      }),
  });
};
